(() => {
  // Track the currently unmuted video globally
  let currentlyUnmutedVideo = null;

  // Intersection Observer for viewport detection
  // NOTE: we WILL NOT pause on leave anymore. Observer only helps start playback if needed.
  const videoObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const video = entry.target;
    const shouldAutoplay = video.dataset.autoplay === 'true';

    if (entry.isIntersecting) {
      // In viewport: autoplay if allowed and user hasn’t manually paused
      if (shouldAutoplay && video.paused && !video.__userPaused) {
        if (currentlyUnmutedVideo !== video) video.muted = true;
        video.play().catch(() => {});
        updateVideoControls(video);
      }
    } else {
      // ❗ Out of viewport: pause video (but do NOT mark as userPaused)
      if (!video.paused) {
        video.pause();
        updateVideoControls(video);
      }
    }
  });
}, { threshold: 0.8 });


  function muteOtherVideos(currentVideo) {
    // Get all videos inside Splide sliders (adjust selector if needed)
    const allVideos = document.querySelectorAll('.splide__slide video');

    allVideos.forEach((video) => {
      if (video === currentVideo) return;

      // Pause and mark as "user paused" so IO doesn't auto-play again
      if (!video.paused) {
        video.pause();
      }
      video.__userPaused = true;

      // Always mute other videos
      video.muted = true;

      // Refresh UI state for each video
      updateVideoControls(video);
    });

    // Track the currently unmuted one
    currentlyUnmutedVideo = currentVideo;
  }


  function updateVideoControls(video) {
    if (!video) return;

    const slideItem = video.closest('.slide-item');
    const playPauseBtn = slideItem?.querySelector('.video-play-pause');
    const muteToggleBtn = slideItem?.querySelector('.video-mute-toggle');
    const playIcon = playPauseBtn?.querySelector('.icon-play');
    const pauseIcon = playPauseBtn?.querySelector('.icon-pause');
    const muteIcon = muteToggleBtn?.querySelector('.icon-mute');
    const unmuteIcon = muteToggleBtn?.querySelector('.icon-unmute');

    // Update Play/Pause Icon
    if (playIcon && pauseIcon) {
      playIcon.style.display = video.paused ? 'block' : 'none';
      pauseIcon.style.display = video.paused ? 'none' : 'block';
    }

    // Update Mute/Unmute Icon + class
    if (muteIcon && unmuteIcon) {
      muteToggleBtn.classList.toggle('is-muted', video.muted);
      muteIcon.style.display = video.muted ? 'block' : 'none';
      unmuteIcon.style.display = video.muted ? 'none' : 'block';
    }
  }

  // Function to attach all control listeners to a single video
  function setupVideoListeners(video) {
    const slideItem = video.closest('.slide-item');
    if (!slideItem) return;
    if (video.dataset.videoListeners === 'true') return;
    video.dataset.videoListeners = 'true';

    const playPauseBtn = slideItem.querySelector('.video-play-pause');
    const muteToggleBtn = slideItem.querySelector('.video-mute-toggle');
    const shouldAutoplay = video.dataset.autoplay === 'true';

    // Track whether the user manually paused this video
    video.__userPaused = false;

    // Play / Pause button
    playPauseBtn?.addEventListener('click', () => {
      if (video.paused) {
        // User requested play -> clear userPaused flag and play
        video.__userPaused = false;
        video.play().catch(() => {});
      } else {
        // User requested pause -> set userPaused flag and pause
        video.__userPaused = true;
        video.pause();
      }
      updateVideoControls(video);
    });

    // Mute toggle
    // Mute toggle
    muteToggleBtn?.addEventListener('click', () => {
      if (video.muted) {
        // ✅ UNMUTE this video: play it and pause/mute all others
        video.muted = false;

        if (video.paused) {
          video.__userPaused = false;
          video.play().catch(() => {});
        }

        muteOtherVideos(video);
      } else {
        // ✅ MUTE this video
        video.muted = true;

        // If this was the only unmuted video, unlock others
        if (currentlyUnmutedVideo === video) {
          currentlyUnmutedVideo = null;

          // All videos can now play again (muted) without confusion
          const allVideos = document.querySelectorAll('.splide__slide video');

          allVideos.forEach((v) => {
            // No video is now "user paused" because we allow autoplay again
            v.__userPaused = false;

            // Keep everything muted to avoid sound confusion
            v.muted = true;

            const shouldAutoplay = v.dataset.autoplay === 'true';

            // Optionally restart playback if they were paused
            if (shouldAutoplay && v.paused) {
              v.play().catch(() => {});
            }

            updateVideoControls(v);
          });
        }
      }

      updateVideoControls(video);
    });



    // Update UI when media state changes
    ['loadeddata', 'play', 'pause', 'volumechange'].forEach(event => {
      video.addEventListener(event, () => updateVideoControls(video));
    });

    // Initial state: start muted and autoplay on load
    const initializeVideoState = () => {
      // Start muted so autoplay can run consistently across browsers
      if (currentlyUnmutedVideo === video) {
        video.muted = false;
      } else {
        video.muted = true;
      }

      // Do NOT treat this as a "user pause"
      video.__userPaused = false;

      // Start playing immediately (muted)
      video.play().catch(() => {
        // autoplay may fail in odd cases; ignore
      });

      // If dataset.autoplay is false we still start playing because the requirement was "on load time all video need to play".
      updateVideoControls(video);
    };

    if (video.readyState >= 1) {
      initializeVideoState();
    } else {
      video.addEventListener('loadedmetadata', initializeVideoState, { once: true });
    }

    videoObserver.observe(video);
  }


  function readConfig(el) {
    const json = el.getAttribute('data-splide');
    if (json) {
      try {
        return JSON.parse(json);
      } catch (e) {
        console.warn('[Splide] Invalid data-splide JSON:', e, json);
      }
    }
    const perDesktop = parseInt(el.dataset.perDesktop || '4', 10);
    const perMobile = parseInt(el.dataset.perMobile || '1', 10);
    return {
      perPage: perDesktop,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: true,
      breakpoints: { 768: { perPage: perMobile } },
    };
  }

  function initSplideFor(root) {
    const els = root.querySelectorAll ? root.querySelectorAll('.custom-splide.splide') : [];
    els.forEach((el) => {
      if (el.dataset.mounted === 'true') return;

      const cfg = readConfig(el);
      const s = new Splide(el, cfg);
      s.mount();
      el.dataset.mounted = 'true';

      // Find all video elements within this Splide instance and set up controls
      el.querySelectorAll('.splide__slide video').forEach(video => {
        if (!video.dataset.videoListeners) {
          setupVideoListeners(video);
          video.dataset.videoListeners = 'true';
        }
      });

      // ✅ Progress bar targeting
      const progressBar = el.parentElement.querySelector('.splide-carousel-progress-bar');
      if (progressBar) {
        const updateProgress = () => {
          const totalSlides = s.length - s.options.perPage;
          const perPage = s.options.perPage;
          const length = s.length;
          const currentIndex = s.index;

          const progress = totalSlides > 0
            ? ((currentIndex + perPage) / length) * 100
            : 0;

          progressBar.style.width = `${progress}%`;
        };

        // Run on mount and slide move
        updateProgress();
        s.on('mounted move', updateProgress);
      }

      // Toggle hidden content
      el.querySelectorAll('.expand-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const slideItem = btn.closest('.slide-item');
          const content = slideItem && slideItem.querySelector('.hidden-content');
          if (!content) return;

          const allItems = el.querySelectorAll('.slide-item');
          allItems.forEach((item) => {
            const itemContent = item.querySelector('.hidden-content');
            const itemBtn = item.querySelector('.expand-btn');

            // Close all others
            if (item !== slideItem) {
              itemContent?.classList.remove('active');
              itemBtn?.classList.remove('active');
            }
          });

          // Toggle current one
          const isActive = content.classList.contains('active');
          content.classList.toggle('active', !isActive);
          btn.classList.toggle('active', !isActive);
        });
      });
    });
  }

  if (window.Splide) initSplideFor(document);
  else document.addEventListener('DOMContentLoaded', () => initSplideFor(document));

  document.addEventListener('shopify:section:load',    (e) => initSplideFor(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initSplideFor(e.target));
  document.addEventListener('shopify:block:select',    (e) => initSplideFor(e.target));
})();
